/**
 * @generated SignedSource<<e3236e46edd9b7d0741d311f60c021cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCostPeriodInput = {
  id: string;
  startDay?: number | null;
  startMonth?: number | null;
  startYear?: number | null;
  cost?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCostPeriodMutationModernMutation$variables = {
  input: UpdateCostPeriodInput;
};
export type updateCostPeriodMutationModernMutation$data = {
  readonly updateCostPeriod: {
    readonly costPeriod: {
      readonly id: string;
      readonly startDay: number | null;
      readonly startMonth: number | null;
      readonly startYear: number | null;
      readonly cost: number | null;
    } | null;
  } | null;
};
export type updateCostPeriodMutationModernMutation = {
  variables: updateCostPeriodMutationModernMutation$variables;
  response: updateCostPeriodMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCostPeriodPayload",
    "kind": "LinkedField",
    "name": "updateCostPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CostPeriod",
        "kind": "LinkedField",
        "name": "costPeriod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cost",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCostPeriodMutationModernMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCostPeriodMutationModernMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8481a40d7e0d3e91722c62d69d4f83c",
    "id": null,
    "metadata": {},
    "name": "updateCostPeriodMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateCostPeriodMutationModernMutation(\n  $input: UpdateCostPeriodInput!\n) {\n  updateCostPeriod(input: $input) {\n    costPeriod {\n      id\n      startDay\n      startMonth\n      startYear\n      cost\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9fb9648cf62acc827cebf3f58d20dc1d";

export default node;
